import * as React from 'react';
import { Radio, UIText2 } from '@cian/ui-kit';

import * as styles from './MainRegions.css';
import { TLocationModalStep } from '../../../../types/locationModal';
import { IRegion } from '../../../../types/regions';

interface IMainRegionsProps {
  mainRegions: IRegion[];
  step: TLocationModalStep;
  currentRegion: IRegion;
  onRegionClick: (region: IRegion) => void;
}

export const MainRegions: React.FC<IMainRegionsProps> = ({ mainRegions, step, currentRegion, onRegionClick }) => {
  return (
    <div data-testid="MainRegions">
      {mainRegions.map((region: IRegion) => (
        <div key={region.id} className={styles['main-region']}>
          {step === 'cities' ? (
            <Radio
              label={region.name}
              onChange={() => onRegionClick(region)}
              checked={region.id === currentRegion.id}
              value={String(region.id)}
              name="city"
            />
          ) : (
            <div className={styles['clickable-text']} onClick={() => onRegionClick(region)}>
              <UIText2 color="current_color">{region.name}</UIText2>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
